import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
import { useProjectFilter, AVAILABLE_PROJECTS } from '../contexts/ProjectFilterContext';
import { useContractorFilter, AVAILABLE_CONTRACTORS } from '../contexts/ContractorFilterContext';
export function FilterPills() {
  const {
    selectedProjects,
    toggleProject
  } = useProjectFilter();
  const {
    selectedContractors,
    toggleContractor
  } = useContractorFilter();
  const allProjectsSelected = selectedProjects.length === AVAILABLE_PROJECTS.length;
  const allContractorsSelected = selectedContractors.length === AVAILABLE_CONTRACTORS.length;
  const hasActiveFilters = !allProjectsSelected || !allContractorsSelected;
  if (!hasActiveFilters) return null;
  return <motion.div initial={{
    opacity: 0,
    y: -10
  }} animate={{
    opacity: 1,
    y: 0
  }} className="flex flex-col gap-2" data-id="element-602" data-mp="3q8iv2y2mwl42">
      {/* Project Pills Row */}
      {!allProjectsSelected && <div className="flex flex-wrap items-center gap-2" data-id="element-603" data-mp="w9hwsd3beddw">
          <span className="text-xs font-semibold text-gray-500 uppercase tracking-wider" data-id="element-604" data-mp="119mcw20b963l">
            Sites:
          </span>
          <AnimatePresence mode="popLayout" data-id="element-605" data-mp="1602pjjwb4now">
            {selectedProjects.map(project => <motion.div key={`project-${project}`} initial={{
          opacity: 0,
          scale: 0.8
        }} animate={{
          opacity: 1,
          scale: 1
        }} exit={{
          opacity: 0,
          scale: 0.8
        }} transition={{
          duration: 0.2
        }} className="inline-flex items-center gap-2 bg-emerald-50 text-emerald-700 px-3 py-1.5 rounded-full text-sm font-medium border border-emerald-200" data-id="element-606" data-mp="1azp4bxrsabzt">
                <span data-id="element-607" data-mp="23m9w2zc68q3w">{project}</span>
                <button onClick={() => toggleProject(project)} className="hover:bg-emerald-100 rounded-full p-0.5 transition-colors" aria-label={`Remove ${project}`} data-id="element-608" data-mp="3lleauo2vufn">
                  <X size={14} data-id="element-609" data-mp="cl8itpc3tgcx" />
                </button>
              </motion.div>)}
          </AnimatePresence>
        </div>}

      {/* Contractor Pills Row */}
      {!allContractorsSelected && <div className="flex flex-wrap items-center gap-2" data-id="element-610" data-mp="3h0zvpph53oc2">
          <span className="text-xs font-semibold text-gray-500 uppercase tracking-wider" data-id="element-611" data-mp="3c2g8zmuq28in">
            Contractors:
          </span>
          <AnimatePresence mode="popLayout" data-id="element-612" data-mp="3pummf16hq1ee">
            {selectedContractors.map(contractor => <motion.div key={`contractor-${contractor}`} initial={{
          opacity: 0,
          scale: 0.8
        }} animate={{
          opacity: 1,
          scale: 1
        }} exit={{
          opacity: 0,
          scale: 0.8
        }} transition={{
          duration: 0.2
        }} className="inline-flex items-center gap-2 bg-blue-50 text-blue-700 px-3 py-1.5 rounded-full text-sm font-medium border border-blue-200" data-id="element-613" data-mp="3l11y60up8lse">
                <span data-id="element-614" data-mp="31xzscr9f4nds">{contractor}</span>
                <button onClick={() => toggleContractor(contractor)} className="hover:bg-blue-100 rounded-full p-0.5 transition-colors" aria-label={`Remove ${contractor}`} data-id="element-615" data-mp="31z1hfzn9raei">
                  <X size={14} data-id="element-616" data-mp="2s1wuvypihcx6" />
                </button>
              </motion.div>)}
          </AnimatePresence>
        </div>}
    </motion.div>;
}